import React from "react";
import PostList from "../components/post/PostList";

const Post = () => {
  return (
    <>
      <PostList />
    </>
  );
};

export default Post;
